<div class="top_info_box" [ngClass]="{logout:logout}">
  
  <img src="assets/img/username.png" alt="" class="img_1"/>
  <img src="assets/img/mc.png" alt=""/>
  <div class="title">{{pageTitle}}</div>
</div>
